<template>
    <div data-v-59e03106="" data-v-43c1797b="" class="footer">
        <ul data-v-59e03106="">
            <li data-v-59e03106="" class="on" onclick="window.location.href='/index/index/home'"><img data-v-59e03106="" src="/static/index/img/black-tb2.png" alt=""><img data-v-59e03106="" src="/static/index/img/black-tb22.png" alt="">
                <p data-v-59e03106="">{{lang.home}}</p>
            </li>
            <li data-v-59e03106="" class="" onclick="window.location.href='/index/order/index'"><img data-v-59e03106="" src="/static/index/img/black-tb3.png" alt=""><img data-v-59e03106="" src="/static/index/img/black-tb33.png" alt="">
                <p data-v-59e03106="">{{lang.order}}</p>
            </li>
            <li data-v-59e03106="" class="t" onclick="window.location.href='/index/rot_order/index'"><img data-v-59e03106="" src="/static/index/img/gif_1.png" alt="" style="height: 1.6rem;"><img data-v-59e03106="" src="/static/index/gif_1.png" alt="" style="height: 1.6rem;"></li>
            <li data-v-59e03106="" class="" onclick="window.location.href='/index/index/kefu'"><img data-v-59e03106="" src="/static/index/img/black-tb4.png" alt=""><img data-v-59e03106="" src="/static/index/img/black-tb44.png" alt="">
                <p data-v-59e03106="">{{lang.customer}}</p>
            </li>
            <li data-v-59e03106="" class="" onclick="window.location.href='/index/my/index'"><img data-v-59e03106="" src="/static/index/img/black-tb1.png" alt=""><img data-v-59e03106="" src="/static/index/img/black-tb11.png" alt="">
                <p data-v-59e03106="">{{lang.user}}</p>
            </li>
        </ul>
    </div>
</template>

<script>
import _g from "@/assets/js/global";
import Lockr from "lockr";

export default {
    data() {
        return {
            lang: {},
        };
    },
    methods: {
    goToLink() {
      window.location.href = this.lang.kefu_link;
    }
  },
  created() {
    this.lang = Lockr.get("lang");
  }
}
</script>

<style scoped src="../../../static/index/css/black.css"></style>



// WEBPACK FOOTER //
// src/components/Common/bottomMenu.vue